import Card from 'reusecore/src/elements/Card';
import Box from 'reusecore/src/elements/Box';
import PageMeta from '../components/PageMeta';
import { useTranslation } from 'next-i18next';
import SignUpForm from '../containers/SignUpForm';
import withPublic         from "../hoc/withPublic";
import simplePage         from "../serverProps/simplePage";

const SignUp = ({ history }) => {
  const { t } = useTranslation();

  return (
    <>
      <PageMeta
        title={t(`${process.env.APP_LOCALIZATION}:register.head.title`)}
        description={t(
          `${process.env.APP_LOCALIZATION}:register.head.description`
        )}
      />
      <Box flexBox justifyContent="center" alignItems="center">
        <Card
          width={470}
          style={{ backgroundColor: 'white' }}
          m={['20px 10px', '40px 20px']}
          p={['40px 15px', '40px 80px']}
          boxShadow="0px 0px 35px rgba(0, 0, 0, 0.03)"
        >
          <SignUpForm history={history} />
        </Card>
      </Box>
    </>
  );
}

export default withPublic(SignUp);

export const getServerSideProps = simplePage;
